import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import { validateHour } from 'utils/validation/validators'
import validateHourInterval from 'utils/validation/validators/validateHourInterval'

export const dynamicHourValidators = (value: string, question: CustomFormQuestion): string => {
  let error = ''
  if (question?.validation) {
    if (question?.validation?.min) {
      if (value && !validateHourInterval(value, { minTime: String(question?.validation?.min) })) {
        error = 'Número mínimo não alcançado'
      }
    }
    if (question?.validation?.max) {
      if (value && !validateHourInterval(value, { maxTime: String(question?.validation?.max) })) {
        error = 'Número máximo ultrapassado'
      }
    }
  }
  return error
}

type ValidateHourOnCustomFormParams = {
  hour: string
  question: CustomFormQuestion
}

export default function validateHourOnCustomForm({ hour, question }: ValidateHourOnCustomFormParams) {
  let error = ''
  if (question.is_required && !hour) {
    error = 'Este campo é obrigatório'
  }
  if (hour) {
    if (!validateHour(hour)) {
      error = 'O horário está inválida'
    }
    const errorMessage = dynamicHourValidators(hour, question)
    if (errorMessage !== '') error = errorMessage
  }
  return error
}
